import { Component, OnInit } from '@angular/core';
import { PrintService } from 'src/app/core/services/print.service';
import { Client } from 'src/app/shared/models/clients/client';
import { Opponent } from 'src/app/shared/models/data/opponent';
import { ExpertSession } from 'src/app/shared/models/hearings/expertSession';
import { User, UserRole } from 'src/app/shared/models/users/user';

@Component({
  selector: 'app-print-expert-sessions',
  templateUrl: './print-expert-sessions.component.html',
  styleUrls: ['./print-expert-sessions.component.scss']
})
export class PrintExpertSessionsComponent implements OnInit {

  sessions: ExpertSession[] = [];
  clients: Client[];
  opponents: Opponent[];
  fileNum: string;
  user: User;
  userRole = UserRole;
  claimNumbers = [];

  constructor(
    private printService: PrintService,
  ) {
    this.sessions = this.printService.data.sessions;
    this.clients = this.printService.data.fileInfo.clients;
    this.opponents = this.printService.data.fileInfo.opponents;
    this.fileNum = this.printService.data.fileInfo.fileNum;
    this.claimNumbers = this.printService.data.fileInfo.claimNumbers;
  }

  ngOnInit(): void {
    this.printService.onDataReady('Expert Sessions');
  }

  isDataEntry() {
    return this.user && (this.user.role === UserRole.ADMIN || this.user.role === UserRole.DATA_ENTRY)
  }


}